module.exports = __webpack_public_path__ + "static/media/recurAmar.d2231976.png";